import { useQuery } from "@tanstack/react-query";
import { type Dayjs } from "dayjs";

import { type CalendarEvent as CalendarEventType } from "@fitness-app/data-models/entities/CalendarEvent";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { supabase } from "~/store/initializeStore";

export const useCalendarEvents = (traineeId?: string, range?: { start: Dayjs; end: Dayjs }) => {
  const { isTeamMember, userId } = useUserRole();
  const { data, isLoading } = useQuery(["calendar_events", traineeId, range], {
    enabled: Boolean(traineeId),
    refetchOnWindowFocus: true,

    queryFn: async () => {
      let query = supabase.from("calendar_event").select("*");

      if (traineeId) {
        query = query.eq("traineeId", traineeId);
      }

      if (isTeamMember) {
        query = query.eq("userId", userId);
      }

      if (range) {
        query = query.gte("startTime", range.start.toISOString()).lte("endTime", range.end.toISOString());
      }

      const { error, data } = await query.order("startTime", { ascending: false }).overrideTypes<CalendarEventType[]>();

      if (error) {
        return [];
      }

      return data;
    },
  });

  return {
    data,
    isLoading,
  };
};
